function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 26.262,
  cy: 26.811,
  r: 15,
  fill: "#000"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 30.012,
  cy: 30.561,
  r: 30,
  fill: "#000"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.116 26.147c-1.182.84-2.004 2.04-2.357 3.557h-2.191v15.428h-4.081V29.704h-2.874v-3.557h2.874V22.59c0-4.715 2.498-7.029 6.372-7.029 1.457 0 2.581.3 3.623.943v3.9c-1-.686-1.916-1.072-3.165-1.072-1.75 0-2.749.9-2.749 3.215v3.6h4.548z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.75 44.018c1.375.943 3.54 1.543 5.706 1.543 3.998 0 6.954-1.8 6.954-5.786 0-3.428-1.832-5.057-6.038-6-2.124-.6-2.915-1.243-2.915-2.486 0-1.242.958-2.142 2.748-2.142 1.958 0 3.54.728 5.164 1.928v-3.9c-1.54-.986-3.206-1.457-5.289-1.457-3.748 0-6.58 1.886-6.58 5.743 0 3.3 1.625 4.886 5.456 5.786 2.374.642 3.456 1.2 3.456 2.742 0 1.5-1.207 2.143-3.04 2.143-1.874 0-3.914-.814-5.622-2.142v4.028z",
  fill: "#fff"
});

function SvgFsMonogramCircleBlk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjEiIGhlaWdodD0iNjEiIHZpZXdCb3g9IjAgMCA2MSA2MSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjYuMjYxNyIgY3k9IjI2LjgxMSIgcj0iMTUiIGZpbGw9ImJsYWNrIi8+CjxjaXJjbGUgY3g9IjMwLjAxMTciIGN5PSIzMC41NjEiIHI9IjMwIiBmaWxsPSJibGFjayIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMwLjExNTYgMjYuMTQ2OEMyOC45MzM5IDI2Ljk4NjEgMjguMTExOCAyOC4xODc1IDI3Ljc1OTQgMjkuNzAzOUgyNS41NjhWNDUuMTMyNUgyMS40ODY4VjI5LjcwMzlIMTguNjEzM1YyNi4xNDY4SDIxLjQ4NjhWMjIuNTg5NkMyMS40ODY4IDE3Ljg3NTMgMjMuOTg1NSAxNS41NjEgMjcuODU4NSAxNS41NjFDMjkuMzE2MSAxNS41NjEgMzAuNDQwNSAxNS44NjEgMzEuNDgxNiAxNi41MDM5VjIwLjQwMzlDMzAuNDgyMSAxOS43MTgyIDI5LjU2NTkgMTkuMzMyNSAyOC4zMTY2IDE5LjMzMjVDMjYuNTY3NSAxOS4zMzI1IDI1LjU2OCAyMC4yMzI1IDI1LjU2OCAyMi41NDY4VjI2LjE0NjhIMzAuMTE1NloiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjguNzUwNCA0NC4wMThDMzAuMTI0NiA0NC45NjA5IDMyLjI5MDIgNDUuNTYwOSAzNC40NTU3IDQ1LjU2MDlDMzguNDUzNyA0NS41NjA5IDQxLjQxMDUgNDMuNzYwOSA0MS40MTA1IDM5Ljc3NTJDNDEuNDEwNSAzNi4zNDY2IDM5LjU3ODEgMzQuNzE4IDM1LjM3MTkgMzMuNzc1MkMzMy4yNDggMzMuMTc1MiAzMi40NTY4IDMyLjUzMjMgMzIuNDU2OCAzMS4yODk0QzMyLjQ1NjggMzAuMDQ2NiAzMy40MTQ2IDI5LjE0NjYgMzUuMjA1MyAyOS4xNDY2QzM3LjE2MjcgMjkuMTQ2NiAzOC43NDUyIDI5Ljg3NTIgNDAuMzY5MyAzMS4wNzUyVjI3LjE3NTJDMzguODI4NSAyNi4xODk0IDM3LjE2MjcgMjUuNzE4IDM1LjA4MDQgMjUuNzE4QzMxLjMzMjQgMjUuNzE4IDI4LjUwMDUgMjcuNjAzNyAyOC41MDA1IDMxLjQ2MDlDMjguNTAwNSAzNC43NjA5IDMwLjEyNDYgMzYuMzQ2NiAzMy45NTYgMzcuMjQ2NkMzNi4zMjk4IDM3Ljg4OTUgMzcuNDEyNSAzOC40NDY2IDM3LjQxMjUgMzkuOTg5NUMzNy40MTI1IDQxLjQ4OTUgMzYuMjA0OCA0Mi4xMzIzIDM0LjM3MjQgNDIuMTMyM0MzMi40OTg0IDQyLjEzMjMgMzAuNDU3OCA0MS4zMTggMjguNzUwNCAzOS45ODk1VjQ0LjAxOFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgFsMonogramCircleBlk as ReactComponent };